module.exports = __webpack_public_path__ + "static/media/12_1.dff245c8.png";